import React from 'react';
import { FadeIn } from './FadeIn';
export function ProtocoloHielo() {
  return <section className="py-10 md:py-32 bg-white" data-id="element-164">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-165">
        <FadeIn data-id="element-166">
          <div className="text-center mb-16" data-id="element-167">
            <span className="text-sage-600 font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-168">
              El Mecanismo Único
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-8" data-id="element-169">
              Presentamos el Protocolo{' '}
              <span className="text-coral-500" data-id="element-170">H.I.E.L.O.</span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-171">
          <FadeIn direction="right" data-id="element-172">
            <div className="space-y-6" data-id="element-173">
              <div className="flex items-center gap-4" data-id="element-174">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-175">
                  H
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-176">
                  Hidratación Celular
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-177">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-178">
                  I
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-179">
                  Intestino Sano
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-180">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-181">
                  E
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-182">
                  Equilibrio de
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-183">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-184">
                  L
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-185">
                  Líquidos y
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-186">
                <span className="text-4xl font-serif font-bold text-sage-300" data-id="element-187">
                  O
                </span>
                <span className="text-xl font-bold text-charcoal font-sans" data-id="element-188">
                  Oxitocina (Cortisol bajo)
                </span>
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-189">
            <div className="bg-sage-50 rounded-3xl p-8 md:p-10 border border-sage-100 relative" data-id="element-190">
              <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-sage-200 rounded-full blur-2xl opacity-50" data-id="element-191"></div>
              <p className="text-lg text-charcoal-light leading-relaxed relative z-10" data-id="element-192">
                A diferencia de las dietas tradicionales, este protocolo no se
                enfoca en la restricción, sino en la{' '}
                <strong className="text-charcoal" data-id="element-193">
                  señalización biológica
                </strong>
                .
                <br data-id="element-194" />
                <br data-id="element-195" />
                Le enseñamos a tu sistema nervioso que "está a salvo" para que
                suelte la retención de líquidos, selle las paredes de tu
                intestino y apague la alarma del cortisol.
                <br data-id="element-196" />
                <br data-id="element-197" />
                <span className="text-xl font-serif italic text-sage-700" data-id="element-198">
                  Cuando la inflamación baja, el peso se cae solo.
                </span>
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}